export default __webpack_public_path__ + "static/media/ic_pencil.a114d44b.svg";